import { writable } from 'svelte/store';
import date from '../lib/date';

import { differenceInMinutes, parse } from 'date-fns';

let store = writable([]);

export default {
    subscribe: store.subscribe,

    load(weekStartDate) {
        return fetch(`/api/events/list?startDate=${date.format(weekStartDate, date.FORMAT_DATE_ISO8601)}`)
        .then(res => {
            if (!res.ok) throw new Error('Oh no');

            return res.json();
        })
        .then(res => {
            let list = res.list.map(ev => {
                let date = parse(ev.evr_from);
                ev.mins = date.getMinutes();
                ev.length = differenceInMinutes(parse(ev.evr_to), date);

                return ev;
            });

            store.set(list);

            return res;
        })
        .catch(e => {
            store.set(null)

            return false;
        });
    },

    reserve(event, user, withCredits, clnIds) {
        let form = new FormData();
        form.set('withCredits', withCredits ? 1 : 0);

        if (clnIds && clnIds.length) {
            for (let i in clnIds) {
                let clnId = clnIds[i];
                form.set(`clnIds[${i}]`, clnId);
            }
        }

        if (user.id) {
            form.set('user', user.id);
        } else {
            for (let prop in user) {
                if (!user.hasOwnProperty(prop)) continue;

                form.set(`user[${prop}]`, user[prop]);
            }
        }

        return fetch(`/api/reserve/${event.evr_id}`, {
            credentials: 'same-origin',
            method: 'POST',
            body: form
        }).then(res => {
            if (!res.ok) throw new Error('Oh no');

            return res.json();
        }).catch(e => {
            return false;
        });
    }
};